import { styled } from '@mui/system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';

const RootDiv = styled('div')({
  display: 'flex',
  margin: '17px 0 0px 0',
  padding: '6px 15px 6px 9px',
  alignItems: 'center',
  backgroundColor: '#E6F3FA',
});

const InfoIcon = styled(InfoOutlinedIcon)({
  color: '##414046',
  fontSize: '22px',
});

const InfoText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '15.6px',
  letterSpacing: '0.15px',
  color: '#414046',
  marginLeft: '12px',
});

export { RootDiv, InfoIcon, InfoText };
